import request from 'api/requestUtils'
import { mapUserCartRequest } from './userCartMappers'

export function syncUserCartForRecommendations(userCartState: App.UserCartState, userId?: string, domainUserId?: string) {
  if (!userId || !domainUserId) return

  const queryParams = new URLSearchParams({ without_brand: '1', le_user_id: userId, domain_user_id: domainUserId })
  const payload = [{ ...mapUserCartRequest(userCartState), isMultiItemMode: true }]

  // Have to use without_brand=1 to disable the brand preprocessor since we are sending an array
  return request.post(`/api/recommendation/high_intent/abandoned_carts?${queryParams}`, payload, {
    credentials: 'include',
  })
}
